/*
 * @Author: liuxiaoyan
 * @Date: 2021-11-05 16:15:52
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2021-12-07 19:18:02
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
/*
 * @Author: 吴文洁
 * @Date: 2020-01-29 09:58:24
 * @LastEditors  : 吴文洁
 * @LastEditTime : 2020-01-29 10:17:18
 * @Description: 直播课次
 */

export default {
  routes: [{
    path: '/growth',
    name: 'growth',
    component: () => import('@/module/growth/GrowthIndex'),
    meta: {
      title: '成长时光',
      keepAlive: true,
      logined: true
    }
  },
  {
    path: '/login-mp',
    name: 'login-mp',
    component: () => import('@/module/webview/LoginMp'),
    meta: {
      title: '获取公众号code',
      keepAlive: true,
      logined: true
    }
  }, {
    path: '/student-course-queue',
    name: 'student-course-queue',
    component: () => import('@/module/order/studentCourseQueuePage/index'),
    meta: {
      title: '我的排队',
      keepAlive: true,
      logined: true
    }
  }, {
    path: '/student-order',
    name: 'student-order',
    component: () => import('@/module/order/OrderPage'),
    meta: {
      title: '我的预约',
      keepAlive: true,
      logined: true
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/Webview.js